import Slider from "react-slick";

import { Animatespin } from "../../components/index";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Functions from "./index.function";
const PartnerSlider = () => {
  const { isLoading, slides, settings, baseURL } = Functions();
  return (
    <>
      {isLoading ? (
        <div className="xs:py-1 sm:py-2 lg:py-3">
          <Animatespin />
        </div>
      ) : (
        <div
          className={`xs:my-1 my-5 ${
            slides.length <= 4
              ? "xs:px-3 sm:px-5"
              : slides.length <= 8
              ? "lg:!px-10"
              : ""
          }`}
        >
          <Slider {...settings}>
            {slides.map((slide, index) => (
              <div key={index} className="px-2">
                <a
                  href={slide?.external_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-center items-center h-full"
                >
                  <img
                    src={`${baseURL}/uploads/partneragency/logo/${slide?.logo}`}
                    alt={`Agency logo ${index}`}
                    className="sm:w-40 sm:h-40 w-40 h-40 object-contain"
                  />
                </a>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
};

export default PartnerSlider;
